
import { defineComponent } from 'vue'
import { IdfButton } from '@invivodf/ui-kit'
import { User } from '../services/user.service'

export default defineComponent({
  name: 'CustomerList',
  components: { IdfButton },
  props: {
    customers: {
      type: Array as () => Array<User>,
      required: true,
    },
  },
  setup() {
    const redirectToCustomerPage = (customer: User) => {
      window.location.href = `/clients/${customer.id}`
    }
    return { redirectToCustomerPage }
  },
})
